import ApplicationsGridRowWrapper from 'components/ApplicationsGrid/components/ApplicationsGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ApplicationsGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <ApplicationsGridRowWrapper ref={ref} testId={testId}>
        {children}
    </ApplicationsGridRowWrapper>
);

export default ApplicationsGridHeader;
